import { createIcon } from '@chakra-ui/react';

export const Register = createIcon({
  displayName: 'Register',
  viewBox: '0 0 24 24',
  path: (
    <g id="SJ-Icon-B_Register_Red_RGB" transform="translate(0.375 0.375)">
      <path
        id="Path_2185"
        data-name="Path 2185"
        d="M25.317,30.857a.563.563,0,0,1-.562-.562v-3.54a1.693,1.693,0,0,0-1.231-1.625l-3.795-1.067a.562.562,0,0,1-.41-.542v-3.7a.705.705,0,1,0-1.411,0v7.821a.563.563,0,0,1-.96.4l-2.011-2.011a.705.705,0,1,0-1,1L16.809,29.9a.562.562,0,0,1-.8.8l-2.871-2.871a1.83,1.83,0,0,1,2.589-2.588l1.05,1.051V19.82a1.83,1.83,0,0,1,3.661,0V23.1l3.384.951a2.823,2.823,0,0,1,2.052,2.708v3.54A.562.562,0,0,1,25.317,30.857Z"
        transform="translate(-8.254 -11.616)"
        fill="currentColor"
      />
      <g
        id="Group_2619"
        data-name="Group 2619"
        transform="translate(5.258 3.104)"
      >
        <path
          id="Path_2186"
          data-name="Path 2186"
          d="M23.165,11.588a.563.563,0,0,1-.52-.348l-.493-1.191a.563.563,0,1,1,1.04-.431l.493,1.191a.563.563,0,0,1-.52.778Z"
          transform="translate(-19.45 -9.271)"
          fill="currentColor"
        />
        <path
          id="Path_2187"
          data-name="Path 2187"
          d="M16.774,17.977a.558.558,0,0,1-.215-.043l-1.191-.493A.563.563,0,1,1,15.8,16.4l1.191.493a.563.563,0,0,1-.216,1.083Z"
          transform="translate(-15.02 -13.7)"
          fill="currentColor"
        />
        <path
          id="Path_2188"
          data-name="Path 2188"
          d="M15.582,26.683a.563.563,0,0,1-.215-1.082l1.191-.494a.562.562,0,0,1,.43,1.039L15.8,26.64A.564.564,0,0,1,15.582,26.683Z"
          transform="translate(-15.019 -19.141)"
          fill="currentColor"
        />
        <path
          id="Path_2189"
          data-name="Path 2189"
          d="M37.792,26.684a.558.558,0,0,1-.215-.043l-1.191-.493a.563.563,0,0,1,.431-1.04l1.191.493a.563.563,0,0,1-.216,1.083Z"
          transform="translate(-28.157 -19.142)"
          fill="currentColor"
        />
        <path
          id="Path_2190"
          data-name="Path 2190"
          d="M36.6,17.98a.563.563,0,0,1-.216-1.082l1.191-.493a.563.563,0,0,1,.431,1.04l-1.191.493A.569.569,0,0,1,36.6,17.98Z"
          transform="translate(-28.157 -13.702)"
          fill="currentColor"
        />
        <path
          id="Path_2191"
          data-name="Path 2191"
          d="M31.376,11.59a.563.563,0,0,1-.52-.778L31.35,9.62a.563.563,0,0,1,1.039.431L31.9,11.242A.563.563,0,0,1,31.376,11.59Z"
          transform="translate(-24.891 -9.272)"
          fill="currentColor"
        />
      </g>
      <g id="Group_2620" data-name="Group 2620">
        <path
          id="Path_2192"
          data-name="Path 2192"
          d="M4.166,20.316a.561.561,0,0,1-.43-.2A11.627,11.627,0,0,1,20.12,3.733a.562.562,0,1,1-.726.86A10.5,10.5,0,0,0,4.6,19.39a.562.562,0,0,1-.43.926Z"
          transform="translate(-0.998 -0.994)"
          fill="currentColor"
        />
        <path
          id="Path_2193"
          data-name="Path 2193"
          d="M19.177,30.8a11.632,11.632,0,0,1-7.495-2.738.563.563,0,1,1,.726-.86,10.5,10.5,0,0,0,14.8-14.8.563.563,0,1,1,.86-.726A11.627,11.627,0,0,1,19.177,30.8Z"
          transform="translate(-7.551 -7.547)"
          fill="currentColor"
        />
      </g>
    </g>
  ),
});
